
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './local';

// 从 localStorage 获取保存的语言，默认为法语
const savedLanguage = typeof window !== 'undefined' ? localStorage.getItem('sethwood-language') || 'fr' : 'fr';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
